<template>
    <div class="mt-4 w-100">
        <vue-headful :title="$t('reports.dashboard.title')" description="title" />
        <h5 class="text-h4 my-6" style="font-weight: bolder">
            {{ currentTab == 0 ? $t('evaluate.titles.assessmentOfReadingProficiency') : $t('evaluate.titles.results')  }}
        </h5>
        <div>
            <BeeTabs
                data-cy="tab-evaluations-btn"
                :items="tabItems"
                :textAlign="`left`"
                @changeTab="setCurrentTab"
                :tabSelected="currentTab"
            />
            <!-- <v-row v-if="isError" class="px-2 py-4">
                <v-alert color="red" dense outlined rounded="xl" text type="error" dismissible @input="closeAlert">
                  {{ getErrorMessage }}
                </v-alert>
            </v-row> -->
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import BeeTabs from '@/components/core/BeeTabs'

export default {
    name: 'Evaluate',
    components: {
        BeeTabs,
    },
    data() {
        return {
            currentTab: 0,
        }
    },
    computed: {
        tabItems() {
            const items = [
                {
                    icon: 'mdi-book-open',
                    text: this.$t('evaluate.titles.assignmentsAndLectures'),
                },
                {
                    icon: 'mdi-chart-timeline-variant-shimmer',
                    text: this.$t('evaluate.titles.results'),
                }
            ]

            return items
        },
    },
    beforeMount() {
        this.checkRoute()
    },
    methods: {
        ...mapActions('reports', ['clearErrors']),
        setCurrentTab(tab) {
            this.currentTab = tab
            switch (tab) {
                case 0:
                    if (this.$router.history.current.name.toLowerCase() === 'assignments_and_lecturres') return
                    return this.$router.push(`/teacher/evaluations/assignments`)
                case 1:
                    if (this.$router.history.current.name.toLowerCase() === 'results')
                        return
                    return this.$router.push(`/teacher/evaluations/results`)
            }
        },
        closeAlert() {
            this.clearErrors()
        },
        checkRoute() {
            switch (this.$router.history.current.name.toLowerCase()) {
                case 'assignments_and_lecturres':
                    this.setCurrentTab(0)
                    break
                case 'results':
                    this.setCurrentTab(1)
                    break
            }
        },
    },
    watch: {
        $route() {
            this.checkRoute()
        },
    },
}
</script>
